/* import __COLOCATED_TEMPLATE__ from './preview.hbs'; */
import Component from '@glimmer/component';
export default class Preview extends Component {
  get showDetailsClass() {
    return this.args.showCardDetails ? 'banking-checking-card-preview__container--rotate' : '';
  }
}